{
  "wave": { "label": "Wave", "clip": "Wave", "durationMs": 2500, "hat": false },
  "curtsy": { "label": "Curtsy", "clip": "Curtsy", "durationMs": 900, "hat": false },
  "bow": { "label": "Bow", "clip": "VisitorBow", "durationMs": 1500, "hat": false },
  "heelclick": {
    "label": "Heel click",
    "clip": "VisitorHeelClick",
    "durationMs": 1300,
    "hat": false
  },
  "hatsoff": { "label": "Hats off", "clip": "VisitorHatsOff", "durationMs": 2400, "hat": true },
  "mlady": { "label": "M’lady", "clip": "VisitorMLady", "durationMs": 1500, "hat": true },
  "avast": { "label": "Avast", "clip": "VisitorAvast", "durationMs": 1500, "hat": false }
}
